import { generateTheme } from "@vividtheory/minerva-legacy/theme";
export const theme = generateTheme({
    palette: {
        primary: {
            main: "#2F5AF0",
            onMain: "#FFFFFF",
            container: "#F6F8FF",
            onContainer: "#1C40C1",
        },
        secondary: {
            main: "#122159",
            onMain: "#FFFFFF",
            container: "#F6F8FF",
            onContainer: "#03082A",
        },
        surface: {
            main: "#1E1E1E",
            onMain: "#FFFFFF",
            container: "#F6F7FB",
            onContainer: "#171A1D",
        },
        success: {
            main: "#12B76A",
            onMain: "#FFFFFF",
            container: "#ECFDF3",
            onContainer: "#053321",
        },
        info: {
            main: "#1570EF",
            onMain: "#FFFFFF",
            container: "#EFF8FF",
            onContainer: "#102A56",
        },
        warning: {
            main: "#F79009",
            onMain: "#FFFFFF",
            container: "#FFFAEB",
            onContainer: "#4E1D09",
        },
        error: {
            main: "#F04438",
            onMain: "#FFFFFF",
            container: "#FEF3F2",
            onContainer: "#55160C",
        },
        disabled: {
            main: "#D0D5DD",
            onMain: "#FFFFFF",
            container: "#F4F5F4",
            onContainer: "#787884",
        },
        background: {
            main: "#FFFFFF",
            onMain: "#14161D",
            container: "#FCFCFD",
            onContainer: "#060B0B",
        },
        outline: "#E0E0E0",
        stroke: {
            50: "#F9FAFB",
            100: "#F2F4F7",
            200: "#E4E7EC",
            300: "#D0D5DD",
        },
    },
    typography: {
        h: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 64,
        },
        h1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 52,
        },
        h2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 42,
        },
        h3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 32,
        },
        h4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 28,
        },
        h5: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 24,
        },
        h6: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 20,
        },
        title1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 18,
        },
        title2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 16,
        },
        title3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 14,
        },
        title4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 12,
        },
        body: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 24,
        },
        body1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 18,
        },
        body2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 16,
        },
        body3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 14,
        },
        body4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 12,
        },
        button: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 14,
        },
        textFieldLabel: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 14,
        },
        textFieldBody: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: 16,
        },
    },
    typographyOptions: {
        fontWeightRegular: 400,
        fontWeightSemiBold: 500,
        fontWeightBold: 700,
    },
});
//# sourceMappingURL=theme.js.map